import type { FinanceAreaKey } from '@/components/Financeiro/solicitacoes/financeSolicitacoesConfig'

/** Títulos no estilo Conecta PJ (hub por área). */
export const PORTAL_HUB_AREA_TITLES: Record<FinanceAreaKey, string> = {
  COMERCIAL: 'Área Comercial | Clientes e contratos',
  PJ: 'Área do Profissional PJ',
  GESTAO: 'Área de Gestão',
  PROCESSOS: 'Área de Processos & Software',
  OUTROS: 'Outros | Demandas comerciais',
}

export const PORTAL_HUB_ALL_TITLE = 'Todas as solicitações'

export function formatTypeListSummary(labels: string[], max = 8): string {
  if (labels.length <= max) return labels.join(', ')
  return `${labels.slice(0, max).join(', ')}, …`
}
